export default {
  lineAt: 'Time2lucky', // Default value
  linkLine: 'https://lin.ee/tqR1wJD', // Default value
  defaultAdminContactLineLink: 'https://lin.ee/tqR1wJD',
  adminContactLineLink: 'https://lin.ee/tqR1wJD',
  domains: [],
  partnerReferralHost: 'time2lucky.com',
  isLoaded: false
}
